module.exports = __webpack_public_path__ + "media/images/header_sp-44eea8163f155ac201768c972838b9cb.jpg";